import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MqttBlockingService {

    private blockedGateways: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

    constructor() { }

    getBlockedGateways(): Observable<string[]> {
        return this.blockedGateways.asObservable();
    }

    addBlockedGateway(identifier: string): void {
        const currentIdentifiers = this.blockedGateways.value;
        if (!currentIdentifiers.includes(identifier)) {
            this.blockedGateways.next([...currentIdentifiers, identifier]);
        }
    }

    hasBlockedGateway(identifier: string): boolean {
        return this.blockedGateways.value.includes(identifier);
    }

    removeBlockedGateway(identifier: string): void {
        const currentIdentifiers = this.blockedGateways.value;
        this.blockedGateways.next(currentIdentifiers.filter(id => id !== identifier));
    }

}
